<template>
  <div>
    <!-- 遮罩层 -->
    <transition name="fade">
      <div
        class="menu-overlay"
        v-show="isOpen"
        @click="closeMenu"
      ></div>
    </transition>

    <!-- 菜单面板 -->
    <transition name="slide">
      <div
        ref="menuPanel"
        class="menu-panel"
        v-show="isOpen"
        @mouseleave="onMenuLeave"
      >
      <!-- 顶部导航 -->
      <nav class="menu-top-nav font-bespoke">
        <a
          href="#"
          class="menu-nav-link"
          :class="{ active: currentSection === 'Collection' }"
          @click.prevent="switchSection('Collection')"
        >
          Collection
        </a>
        <a
          href="#"
          class="menu-nav-link"
          :class="{ active: currentSection === 'Info' }"
          @click.prevent="switchSection('Info')"
        >
          Info
        </a>
        <a
          href="#"
          class="menu-nav-link"
          :class="{ active: currentSection === 'Projects' }"
          @click.prevent="switchSection('Projects')"
        >
          HAHA!
        </a>
      </nav>

      <!-- 菜单内容区域 -->
      <div class="menu-content">
        <!-- Collection 内容 -->
        <div v-if="currentSection === 'Collection'" class="menu-section">
          <div class="category-section" v-for="block in collectionBlocks" :key="block.title">
            <div class="category-header">
              <h2 class="category-title">{{ block.title }}</h2>
              <a
                v-if="block.title === 'TABLE'"
                href="#"
                class="view-all"
                @click.prevent="onViewAllClick('table')"
              >
                VIEW ALL
              </a>
            </div>
            <ul class="category-list">
              <li v-for="item in block.items" :key="item.key">
                <a
                  href="#"
                  class="category-item"
                  @mouseenter="onItemEnter(item, block.section)"
                  @mouseleave="onItemLeave"
                  @click.prevent="onItemClick(item, block.section)"
                >
                  {{ item.label }}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <!-- Info 内容 -->
        <div v-if="currentSection === 'Info'" class="menu-section">
          <div class="info-section" v-for="block in infoBlocks" :key="block.title">
            <div class="info-header">
              <h2 class="section-title">{{ block.title }}</h2>
              <!-- <a
                v-if="block.title === 'ABOUT'"
                href="#"
                class="view-all"
                @click.prevent="onViewAllClick('about')"
              >
                VIEW ALL
              </a> -->
            </div>
            <ul class="info-list" v-if="block.items && block.items.length">
              <li v-for="item in block.items" :key="item.key">
                <a
                  href="#"
                  class="info-item"
                  @mouseenter="onItemEnter(item, block.section)"
                  @mouseleave="onItemLeave"
                  @click.prevent="onItemClick(item, block.section)"
                >
                  {{ item.label }}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <!-- Projects 内容 -->
        <div v-if="currentSection === 'Projects'" class="menu-section">
          <div class="projects-section">
            <a
              href="#"
              class="view-all-link"
              @mouseenter="onItemEnter({ key: 'all-projects', label: 'All Projects' }, 'projects')"
              @mouseleave="onItemLeave"
              @click.prevent="onItemClick({ key: 'all-projects', label: 'All Projects' }, 'projects')"
            >
              denHolm United
            </a>
          </div>
        </div>

      </div>

      <!-- 底部链接 -->
      <div class="menu-bottom-links">
        <a
          href="#"
          class="menu-link-bottom"
          @click.prevent="onBottomLinkClick('login')"
        >
          Login
        </a>
        <a
          href="#"
          class="menu-link-bottom"
          @click.prevent="onBottomLinkClick('subscribe')"
        >
          Subscribe
        </a>
      </div>
    </div>
    </transition>

    <!-- 右侧内容区域 -->
    <transition name="drawer-slide">
      <div
        class="right-content-area"
        :class="{ 'is-collapsed': isContentCollapsed }"
        :style="{
          left: menuPanelWidth
        }"
        v-if="isOpen"
      >
        <div class="right-content-inner">
          <img
            v-if="currentHeroImage"
            :src="currentHeroImage"
            :alt="currentHeroTitle"
            class="hero-image"
          />
          <div class="hero-title" v-if="currentHeroTitle" :key="currentHeroKey">
            {{ currentHeroTitle }}
          </div>
        </div>
      </div>
    </transition>

    <!-- Top Right Icons -->
    <div class="menu-top-right-icons" v-if="isOpen">
      <button class="icon-btn" @click.stop="toggleSearch">
        <img src="../assets/icon/search.png" alt="search" class="icon-img" />
      </button>
      <button class="icon-btn" @click.stop="openUserInfo">
        <img src="../assets/icon/user.png" alt="search" class="icon-img" />
      </button>
      <button class="icon-btn" @click.stop="openEnquiry">
        <img src="../assets/icon/product.png" alt="search" class="icon-img" />
      </button>
    </div>

  </div>
</template>

<script>
import { getCategoryList } from '@/api/product'

// Import mock product images
const prod1 = require('@/assets/Group 1-1.png')
const prod2 = require('@/assets/Group 1-2.png')
const prod3 = require('@/assets/Group 1-3.png')
const prod4 = require('@/assets/Group 1-4.png')

export default {
  name: 'Menu',
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      currentSection: 'Collection',
      hoverTimer: null,
      animationTimer: null,
      isContentCollapsed: false,
      isFirstHover: true,
      currentHeroKey: null,
      menuPanelWidth: '0rem',
      currentHeroImage: null,
      currentHeroTitle: '',
      collectionBlocks: [
        {
          title: 'TABLE',
          section: 'collection',
          items: [
            { key: 'entry-table', label: 'Entry Table' },
            { key: 'console-table', label: 'Console Table' },
            { key: 'coffee-table', label: 'Coffee Table' },
            { key: 'side-table', label: 'Side Table' }
          ]
        },
        {
          title: 'SEATING',
          section: 'collection',
          items: [
            { key: 'chair', label: 'Chair' },
            { key: 'stool', label: 'Stool' }
          ]
        },
        {
          title: 'ACCESSORIES',
          section: 'collection',
          items: [
            { key: 'planter', label: 'Planter' },
            { key: 'lighting', label: 'Lighting' },
            { key: 'mirror', label: 'Mirror' },
            { key: 'hardware', label: 'Hardware' },
            { key: 'decor', label: 'Decor' }
          ]
        }
      ],
      infoBlocks: [
        {
          title: 'ABOUT',
          section: 'info',
          items: [
            { key: 'About', label: 'About Us' , CategoryImage: require('@/assets/_DSC0544 2 3.jpg') },
            { key: 'Founder', label: 'Founder' , CategoryImage: require('@/assets/_DSC0544 2 4.jpg') }
          ]
        },
        {
          title: 'Contact',
          section: 'info',
          items: [
            { key: 'Contact', label: 'Contact' , CategoryImage: require('@/assets/renwu.jpg')}
          ]
        }
      ],
      // 图片映射
      heroImages: {
        // Collection 图片
        'collection-entry-table': require('../assets/_DSC0544 2 2.png'),
        'collection-console-table': require('../assets/Group 1.png'),
        'collection-coffee-table': require('../assets/Group 1-1.png'),
        'collection-side-table': require('../assets/Group 1-2.png'),
        'collection-chair': require('../assets/_DSC0544 2 3.png'),
        'collection-stool': require('../assets/_DSC0544 2 3-1.png'),
        'collection-planter': require('../assets/_DSC0544 2 4.jpg'),
        'collection-lighting': require('../assets/_DSC0544 2 3.png'),
        'collection-mirror': require('../assets/_DSC0544 2 3-1.png'),
        'collection-hardware': require('../assets/_DSC0544 2 4.jpg'),
        'collection-decor': require('../assets/_DSC0544 2 3.png'),
        // Info 图片
        'info-about-us': require('../assets/_DSC0544 2 3.jpg'),
        'info-founder': require('../assets/_DSC0544 2 4.jpg'),
        // Projects 图片
        'projects-all-projects': require('../assets/uni.png'),
        // 默认图片
        'collection-default': require('../assets/Group 1-1.png'),
        'info-default': require('../assets/_DSC0544 2 4.jpg'),
        'projects-default': require('../assets/_DSC0544 2 3.png'),
        'default': require('../assets/home_bg.jpg')
      }
    }
  },
  computed: {
    currentOpenComponent() {
      if (this.isLoginOpen) return 'login'
      if (this.isUserInfoOpen) return 'userInfo'
      if (this.isEnquiryOpen) return 'enquiry'
      if (this.showSearch) return 'search'
      return null
    }
  },
  watch: {
    isOpen(newVal) {
      if (newVal) {
        this.currentSection = 'Collection'
        this.emitHero({ key: 'collection-default', title: '' })
        this.isContentCollapsed = true // 初始状态为收缩
        this.isFirstHover = true // 重置第一次移入标记
        this.fetchCollectionBlocks()
        // 获取菜单面板宽度
        this.$nextTick(() => {
          this.updateMenuPanelWidth()
        })
      } else {
        this.menuPanelWidth = '0rem'
      }
    }
  },
  mounted() {
    // 监听窗口大小变化
    window.addEventListener('resize', this.updateMenuPanelWidth)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateMenuPanelWidth)
  },
  methods: {
    closeMenu() {
      this.$emit('close')
    },

    switchSection(section) {
      this.currentSection = section
      const defaults = {
        Collection: { key: 'collection-default', title: '' },
        Info: { key: 'info-default', title: '' },
        Projects: { key: 'projects-default', title: '' }
      }
      this.emitHero(defaults[section] || { key: 'default', title: '' })
      if (section === 'Collection' && this.isOpen) {
        this.fetchCollectionBlocks()
      }
    },
    normalizeCategoryKey(value) {
      return String(value || '')
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9\s-]/g, '')
        .replace(/\s+/g, '-')
    },
    async fetchCollectionBlocks() {
      if (this.currentSection !== 'Collection') return
      try {
        const response = await getCategoryList()
		console.log(response)
        const list = Array.isArray(response) ? response : (response && Array.isArray(response.result) ? response.result : [])
        if (!list.length) return
        this.collectionBlocks = list.map((block) => {
          const items = Array.isArray(block.Items) ? block.Items : []
          return {
            title: block.CategoryName,
            section: 'collection',
            items: items.map((item) => ({
              key: this.normalizeCategoryKey(item.CategoryName),
              label: item.CategoryName,
              CategoryImage: item.CategoryImage,
              CategoryID: item.CategoryID
            }))
          }
        })
      } catch (error) {
        console.error('Failed to load collection categories:', error)
      }
    },

    onItemClick(item, section) {
      const key = item.key
	  
	  // 处理 Projects 区块中的 denHolm United → 打开外部链接
	    if (section === 'projects' && key === 'all-projects') {
	      window.open('https://www.denholm-united.com', '_blank')
	      this.closeMenu()
	      return
	    }
		
      // 需要跳转的页面列表
      const routePages = ['About', 'Contact', 'Founder']

      if (routePages.includes(key)) {
        // 跳转到对应页面，并关闭菜单
        this.$router.push({ name: key })
        this.closeMenu()
      } else {
        // 处理其他页面的跳转
        this.handleCollectionItemClick(item, section)
      }
    },

    handleCollectionItemClick(item, section) {
      const key = item && item.key ? item.key : ''
      const categoryId = item && (item.CategoryID || item.categoryId) ? (item.CategoryID || item.categoryId) : null
      // Collection 分类的跳转逻辑
      switch(section) {
        case 'collection':
          // 跳转到对应产品分类页
          this.$router.push({
            name: 'ProductIndex',
            query: categoryId ? { CategoryID: String(categoryId) } : {}
          })
          break
        case 'info':
          // Info 页面的其他跳转
          console.log('跳转到 info 页面:', key)
          break
        case 'projects':
          // 跳转到项目页面
          this.$router.push({ name: 'Projects' })
          break
        default:
          // 默认处理
          console.log('跳转到:', key, section)
          break
      }

      // 跳转后关闭菜单
      this.closeMenu()
    },

    onItemEnter(item, section) {
      // 更新右侧区域位置
      const width = this.$refs.menuPanel.offsetWidth
      this.menuPanelWidth = `${width}rem`

      // 鼠标悬停显示对应的图片
      if (this.hoverTimer) clearTimeout(this.hoverTimer)

      this.hoverTimer = setTimeout(() => {
        const newKey = `${section}-${item.key}`

        // 如果内容相同且面板已展开，不做任何操作
        if (this.currentHeroKey === newKey && !this.isContentCollapsed) return

        // 如果是第一次移入，直接展开
        if (this.isFirstHover) {
          this.updateHeroImage({
            key: newKey,
            title: item.label,
            image: item.CategoryImage
          })
          this.isContentCollapsed = false
          this.isFirstHover = false
          return
        }

        // 非第一次移入（切换），等待收缩动画完成后再展开
        this.isContentCollapsed = true

        if (this.animationTimer) {
          clearTimeout(this.animationTimer)
        }

        this.animationTimer = setTimeout(() => {
          this.updateHeroImage({
            key: newKey,
            title: item.label,
            image: item.CategoryImage
          })
          this.isContentCollapsed = false
          this.animationTimer = null
         }, 600) // 600ms 应与 CSS 收缩时长匹配（0.6s = 600ms）
        }, 0) // 保留 40ms hover 延迟
    },

    onMenuLeave() {
      if (this.hoverTimer) {
        clearTimeout(this.hoverTimer)
        this.hoverTimer = null
      }
      if (this.animationTimer) {
        clearTimeout(this.animationTimer)
        this.animationTimer = null
      }
      this.isContentCollapsed = true
      this.isFirstHover = true
    },

    onItemLeave() {
      if (this.hoverTimer) {
        clearTimeout(this.hoverTimer)
        this.hoverTimer = null
      }
      this.isContentCollapsed = true
    },

    updateHeroImage(payload) {
      const { key, title, image } = payload || {}
      debugger
      // 更新当前显示的图片和标题
      if (image) {
        this.currentHeroImage = image
        this.currentHeroTitle = title
        this.currentHeroKey = key || null
      } else if (key && this.heroImages[key]) {
        this.currentHeroImage = this.heroImages[key]
        this.currentHeroTitle = title
        this.currentHeroKey = key
      } else {
        // 使用默认图片
        const defaultKey = this.currentSection.toLowerCase() + '-default'
        this.currentHeroImage = this.heroImages[defaultKey] || this.heroImages.default
        this.currentHeroTitle = title || ''
        this.currentHeroKey = this.heroImages[defaultKey] ? defaultKey : 'default'
      }

      // 同时通知父组件
      this.emitHero(payload)
    },

    resetHero() {
      const defaultKey = this.currentSection.toLowerCase() + '-default'
      this.currentHeroImage = this.heroImages[defaultKey] || this.heroImages.default
      this.currentHeroTitle = ''
      this.currentHeroKey = this.heroImages[defaultKey] ? defaultKey : 'default'
      this.emitHero({ key: defaultKey, title: '' })
    },

    emitHero(payload) {
      this.$emit('hero-change', payload || { key: 'default', title: '' })
    },

    updateMenuPanelWidth() {
      if (this.$refs.menuPanel && this.isOpen) {
        const width = this.$refs.menuPanel.offsetWidth
        this.menuPanelWidth = `${width}rem`
      }
    },

    onViewAllClick(type) {
      // VIEW ALL 链接的点击处理
      switch(type) {
        case 'table':
          // this.$router.push({ name: 'ProductIndex' })
		  this.$router.push({
		    name: 'ProductIndex',
		    query: { CategoryID: 0 } 
		  })
          break
        case 'about':
          this.$router.push({ name: 'About' })
          break
        default:
          this.$router.push({ name: 'ViewAll', params: { type } })
      }
      this.closeMenu()
    },

    // onBottomLinkClick(type) {
    //   // 底部链接的点击处理
    //   const linkMap = {
    //     login: '/login',
    //     subscribe: '/subscribe'
    //   }

    //   if (type === 'login') {
    //     this.$emit('toggle-login')
    //     return
    //   }

    //   if (linkMap[type]) {
    //     this.$router.push(linkMap[type])
    //     this.closeMenu()
    //   }
    // },
	onBottomLinkClick(type) {
	  const linkMap = {
	    login: '/login',
	    // 移除 subscribe 的路由映射
	  }
	  if (type === 'login') {
	    this.$emit('toggle-login')
	    return
	  }
	  if (type === 'subscribe') {
	    // 发出事件，通知父组件（Header）打开邮件弹窗
	    this.$emit('toggle-subscribe')
	    this.closeMenu() // 关闭菜单（可选，根据需求决定）
	    return
	  }
	  // 其他链接按原有逻辑处理
	  if (linkMap[type]) {
	    this.$router.push(linkMap[type])
	    this.closeMenu()
	  }
	},

    // New methods for icons/components
    closeAllComponents() {
      const component = this.currentOpenComponent

      this.isLoginOpen = false
      this.isUserInfoOpen = false
      this.isEnquiryOpen = false
      this.showSearch = false
      this.searchQuery = ''
      this.showSearchResult = false

      if (!component) return Promise.resolve()

      let duration = 400
      if (component === 'enquiry') duration = 800

      return new Promise(resolve => setTimeout(resolve, duration))
    },

    async openLogin() {
      if (this.isAnimating) return

      const hadOpen = !!this.currentOpenComponent
      if (hadOpen) {
        this.isAnimating = true
        await this.closeAllComponents()
      }

      this.isLoginOpen = true
      // document.body.style.overflow = 'hidden' // Menu already handles this?

      if (hadOpen) {
        this.isAnimating = false
      }
    },

    closeLogin() {
      this.isLoginOpen = false
    },

    async openUserInfo() {
      this.$emit('toggle-user-info')
    },


    async openEnquiry() {
      this.$emit('toggle-enquiry')
    },

    switchToMenu() {
      // Logic when switching back from Login?
      // In Header, it calls openMenu().
      // Here, Menu is already open. Just close Login.
      this.closeLogin()
    },

    async toggleSearch() {
      this.$emit('toggle-search')
    },

    handleInput() {
      this.showSearchResult = false
      this.searchConfirmed = false
    },

    performSearch() {
      if (this.searchQuery.trim()) {
        console.log('Searching for:', this.searchQuery)
        // this.$emit('search', this.searchQuery)
        this.showSearchResult = true
        this.searchConfirmed = true
      }
    },

    handleBlur() {
      if (this.searchQuery == "") {
        this.showSearchResult = false
      } else {
        this.showSearchResult = true
      }
    },

    handleScroll(e) {
      if (!this.showSearchResult || this.isLoadingMore) return

      const { scrollTop, clientHeight, scrollHeight } = e.target
      if (scrollHeight - scrollTop - clientHeight < 100) {
        this.loadMoreResults()
      }
    },

    loadMoreResults() {
      this.isLoadingMore = true
      setTimeout(() => {
        const moreProducts = [
          { name: 'Product ' + (this.searchResults.length + 1), image: require('@/assets/Group 1-1.png') },
          { name: 'Product ' + (this.searchResults.length + 2), image: require('@/assets/Group 1-2.png') },
          { name: 'Product ' + (this.searchResults.length + 3), image: require('@/assets/Group 1-3.png') },
          { name: 'Product ' + (this.searchResults.length + 4), image: require('@/assets/Group 1-4.png') }
        ]
        this.searchResults = [...this.searchResults, ...moreProducts]
        this.isLoadingMore = false
      }, 1500)
    }
  }
}
</script>

<style scoped>
.icon-img{
  width: 22rem;
  height: 22rem;
}
/* 遮罩层 */
.menu-overlay {
  position: fixed;
  top: 0;
  left: 0%;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 998;
  /* max-width: calc(100% - 500rem); */
  max-width: 100%;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.8s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.info-item:hover {
  color: #000;
  font-family: 'BespokeSerif-Italic', sans-serif !important;
  font-weight: 400 !important;
}

@media (max-width: 1024px) {
  .menu-overlay {
    left: 40%;
    max-width: calc(100% - 40%);
  }
}

@media (max-width: 768px) {
  .menu-overlay {
    /* 移动端菜单全屏，遮罩层也全屏 */
    left: 0;
    max-width: 100%;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* 菜单面板 */
.menu-panel {
  position: fixed;
  top: 0;
  left: 0;
  width: 32.14%;
  max-width: 486rem;
  height: 100vh;
  background: #ffffff;
  z-index: 10001;
  display: flex;
  flex-direction: column;
  padding: 40rem;
  padding-top: 48rem;
  overflow-y: auto;
  border-right: 2rem solid rgba(0, 0, 0, 1);
}

.slide-enter-active,
.slide-leave-active {
  transition: transform 0.8s cubic-bezier(0.19, 1, 0.22, 1);
}

.slide-enter,
.slide-leave-to {
  transform: translateX(-100%);
}

.drawer-slide-enter-active,
.drawer-slide-leave-active {
  transition: transform 0.8s cubic-bezier(0.19, 1, 0.22, 1);
}

.drawer-slide-enter,
.drawer-slide-leave-to {
  transform: translateX(-100%);
}

/* 右侧内容区域 */
.right-content-area {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  width: 32.14%;
  max-width: 486rem;
  background: #000;
  z-index: 10000;
  /* left 和 transform 的过渡动画，用于跟随菜单宽度变化及折叠展开效果 */
  /* 改为 transform 过渡，不再过渡 width */
  transition: left 0.6s cubic-bezier(0.19, 1, 0.22, 1), 
  transform 1s cubic-bezier(0.19, 1, 0.22, 1);
  overflow: hidden;
  border-right: 2rem solid rgba(0, 0, 0, 1);
}

.right-content-area.is-collapsed {
  /* 折叠时整体向左平移 100% (隐藏到菜单面板下方)，而不是宽度变 0 */
  transform: translateX(-200%);
  /* 向左移动（折叠）时速度稍微慢一点 */
  /* 使用 ease-in 曲线 (0.42, 0, 1, 1) 让动画在结束时保持高速，不会有缓慢停止的感觉 */
  transition: left 0.6s cubic-bezier(0.19, 1, 0.22, 1), 
  transform 0.3s cubic-bezier(0.42, 0, 1, 1);
}

.right-content-inner {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.hero-image {
  width: 100%;
  height: 100%;
  max-height: 100%;
  object-fit: cover;
  object-position: center;
  opacity: 0;
  animation: fadeIn 0.8s cubic-bezier(0.19, 1, 0.22, 1) forwards;
}

.hero-title {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #ffffff;
  font-size: 20rem;
  font-weight: 700;
  text-transform: uppercase;
  text-align: center;
  font-family: 'Apercu-Bold', serif;
  width: 100%;
  padding: 0 20rem;
  pointer-events: none;
  /* text-shadow: 2rem 2rem 4rem rgba(0, 0, 0, 0.5); */
  white-space: nowrap;
  opacity: 0;
  animation: textSlideIn 0.8s cubic-bezier(0.19, 1, 0.22, 1) forwards;
  animation-delay: 0.1s;
}

@keyframes textSlideIn {
  from {
    opacity: 0;
    transform: translate(-60%, -50%);
  }
  to {
    opacity: 1;
    transform: translate(-50%, -50%);
  }
}

/* 顶部导航 */
.menu-top-nav {
  display: flex;
  gap: 30rem;
  margin-bottom: 87rem;
}

.menu-nav-link {
  color: rgba(0, 0, 0, 0.3);
  text-decoration: none;
  font-size: 20rem;
  font-weight: 400;
  transition: color 0.3s;
  position: relative;
}

.menu-nav-link:hover {
  color: #000;
}

.menu-nav-link.active {
  color: #000;
  font-weight: 400;
}

/* 菜单内容 */
.menu-content {
  flex: 1;
  padding-left: 7rem;
}

.menu-section {
  display: flex;
  flex-direction: column;
  gap: 50rem;
}

/* Collection 样式 */
.category-section {
  display: flex;
  flex-direction: column;
  gap: 10rem;
}

.category-header {
  display: flex;
  align-items: baseline;
  gap: 20rem;
}

.category-title {
  font-size: 20rem;
  font-weight: 500;
  color: #000;
  margin: 0;
  text-transform: uppercase;
  font-family: 'Apercu', sans-serif;
}

.view-all {
  font-size: 20rem;
  font-weight: 500;
  color: #000;
  text-decoration: none;
  text-transform: uppercase;
  transition: opacity 0.3s;
  margin-left: 80rem;
  font-family: 'Apercu', sans-serif;
}

.view-all:hover {
  opacity: 0.6;
}

.category-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
}

.category-item {
  font-size: 16rem;
  font-weight: 500;
  height: 19rem;
  color: #333;
  text-decoration: none;
  transition: color 0.3s;
  cursor: pointer;
  font-family: 'Apercu-Medium', sans-serif;
}

.category-item:hover {
  color: #000;
  font-family: 'BespokeSerif-Italic', sans-serif !important;
  font-weight: 400 !important;
}

/* Info 样式 */
.info-section {
  display: flex;
  flex-direction: column;
  gap: 10rem;
}

.info-header {
  display: flex;
  align-items: baseline;
  gap: 5rem;
}

.section-title {
  font-size: 20rem;
  font-weight: 500;
  color: #000;
  margin: 0;
  text-transform: uppercase;
}

.info-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  margin-top: 10rem;
}

.info-item {
  font-size: 16rem;
  font-weight: 500;
  color: #333;
  text-decoration: none;
  transition: color 0.3s;
  cursor: pointer;
}

.info-item:hover {
  color: #000;
}

/* Projects 样式 */
.projects-section {
  margin-top: 20rem;
}

.view-all-link {
  font-size: 20rem;
  font-weight: 500;
  color: #000;
  text-decoration: none;
 /* text-transform: uppercase; */
  transition: opacity 0.3s;
}

.view-all-link:hover {
  opacity: 0.6;
}

/* 底部链接 */
.menu-bottom-links {
  display: flex;
  flex-direction: column;
  margin-top: auto;
  padding-top: 40rem;
}

.menu-link {
  color: #333;
  text-decoration: none;
  font-size: 13rem;
  transition: color 0.3s;
  cursor: pointer;
}

.menu-link-bottom{
  color: rgba(0, 0, 0, 1);
  text-decoration: none;
  font-size: 20rem;
  transition: color 0.3s;
  cursor: pointer;
  font-family: 'BespokeSerif';
}

.menu-link:hover {
  color: #000;
}

@media (max-width: 768px) {
  .menu-panel {
    width: 80%;
    padding: 20rem;
    z-index: 9999;
  }

  .menu-top-nav {
    gap: 15rem;
    margin-bottom: 40rem;
  }

  .right-content-area {
    display: none;
  }

  .hero-title {
    font-size: 32rem;
  }

  .view-all {
    margin-left: 40rem;
  }
}

/* Top Right Icons */
.menu-top-right-icons {
  position: fixed;
  top: 21rem;
  right: 40rem;
  display: flex;
  gap: 23rem;
  z-index: 10002;
  color: #fff;
  margin-top: 22rem;
}

.icon-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 8rem;
  color: inherit;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.3s ease;
}

.icon-btn:hover {
  opacity: 0.7;
}
</style>
